export enum CustomerIOEvents {
  GAME_CLOSED = 'game_closed',
  PWA_OPENED = 'pwa_lu_opened',
}
